import { render, staticRenderFns } from "./signupForm.vue?vue&type=template&id=013c0c6f&"
import script from "./signupForm.vue?vue&type=script&lang=js&"
export * from "./signupForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports